module.exports = function() {
  return new Worker(__webpack_public_path__ + "683b7345e1f7f1e834d4.worker.js");
};